import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Roberto M.',
    age: '52 años',
    city: 'Ciudad de México',
    quote: 'Llevaba 3 años tomando ibuprofeno cada mañana. A la semana de usar el método LSA, mi esposa no podía creer que me levantara sin quejarme. Hoy camino 5 km diarios.'
  }, {
    name: 'Carlos G.',
    age: '61 años',
    city: 'Bogotá',
    quote: 'Mi doctor me dijo que necesitaba cirugía de rodilla. Decidí probar esto primero. Llevo 4 meses y la cirugía ya no es necesaria. Ojalá lo hubiera encontrado antes.'
  }, {
    name: 'Miguel Á.',
    age: '48 años',
    city: 'Madrid',
    quote: 'Soy albañil y el dolor de espalda me estaba robando el trabajo. Con 10 minutos en la cama antes de levantarme, rindo el doble. Mi cuerpo me lo agradece.'
  }];
  return <section className="bg-stone-900 text-stone-50 py-24 px-4 border-t border-stone-800" data-id="element-181">
      <div className="max-w-6xl mx-auto" data-id="element-182">
        <FadeIn data-id="element-183">
          <h2 className="text-3xl md:text-4xl font-black mb-16 text-center text-stone-50" data-id="element-184">
            Lo que dicen quienes ya lo probaron
          </h2>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-185">
            {testimonials.map((t, i) => <FadeIn key={i} delay={i * 0.2} data-id="element-186">
                <div className="bg-stone-950 p-8 rounded-2xl border border-stone-800 shadow-xl h-full flex flex-col" data-id="element-187">
                  <div className="flex gap-1 mb-6" data-id="element-188">
                    {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-amber-500 text-amber-500" data-id="element-189" />)}
                  </div>
                  <p className="text-lg text-stone-300 italic mb-8 flex-grow" data-id="element-190">
                    "{t.quote}"
                  </p>
                  <div className="border-t border-stone-800 pt-4" data-id="element-191">
                    <p className="font-bold text-stone-100" data-id="element-192">{t.name}</p>
                    <p className="text-stone-500 text-sm" data-id="element-193">
                      {t.age}, {t.city}
                    </p>
                  </div>
                </div>
              </FadeIn>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}